import React, { useEffect, useState } from "react";
import { Table, Pagination, Container, Button, Modal, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const ItemsAssign = () => {

    const apiUrl = "https://jwapi.infosware-test.in";
    const { customerId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const customerName = queryParams.get("name");

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        items: "",
        number: "",
        group: "",
        description: "",
        altcode: "",
        type: "",
        date: "",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const [currentItem, setCurrentItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedGemstoneIndex, setSelectedGemstoneIndex] = useState(0); // State for selected gemstone index

    const handleItemClick = async (item) => {
        try {
            const response = await axios.get(`${apiUrl}/api/approval/item-details/${item.number}`); // Fetch data for the selected item's ID
            setCurrentItem(response.data); // Set the fetched data as the current item
            setShowModal(true); // Open the modal
        } catch (error) {
            // console.error("Error fetching item details:", error);
            toast.error("Failed to fetch item details. Please try again.");
        }
    };

    const handleModalClose = () => {
        setCurrentItem(null);
        setShowModal(false);
    };

    const handleRemoveItem = async (item) => {
        if (window.confirm("Are you sure you want to remove this item?")) {
            try {
                await axios.post(`${apiUrl}/api/approval/remove-item`, {
                    customerId,
                    itemId: item.number,
                    itemType: item.type,
                });
                toast.success("Item removed successfully!");
                setData((prevData) => prevData.filter((row) => row.number !== item.number));
            } catch (error) {
                // console.error("Error removing item:", error.response || error.message);
                toast.error("Failed to remove item. Please try again.");
            }
        }
    };

    const renderDetails = (item = false) => {
        const entries = Object.entries(item).filter(
            ([key]) => key !== "photos" && key !== "type" && key !== "otheritems" && key !== "created_at"
        );

        const photos = Array.isArray(item.photos) ? item.photos : JSON.parse(item.photos || '[]');
        let otherItems = [];
        try {
            otherItems = Array.isArray(item.otheritems) ? item.otheritems : JSON.parse(item.otheritems || '[]');
        } catch (error) {
            // console.error('Error parsing otheritems:', error);
        }

        return (
            <>
                <Row>
                    <Col md={4} className="mb-2">
                        <div>
                            <strong>Item Type :</strong> {item.type}
                        </div>
                    </Col>
                </Row>
                {photos.length > 0 && (
                    <Row className="mb-2">
                        <Col>
                            <div className="photos-container d-flex justify-content-start">
                                {photos.map((photo, idx) => (
                                    <div key={idx} className="photo-thumbnail-container mr-2">
                                        <img
                                            src={`${apiUrl}/${photo}`}
                                            alt={`Photo ${idx + 1}`}
                                            className="photo-thumbnail"
                                        />
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                )}
                <Row>
                    {entries.map(([key, value], index) => (
                        <Col md={4} className="mb-2" key={index}>
                            <div>
                                <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                            </div>
                        </Col>
                    ))}
                </Row>
                {otherItems.length > 0 && (
                    <div>
                        <Row className="align-items-center">
                            <Col md={4}>
                                <Form.Label className="mt-3"><h5>Select Otheritems :</h5></Form.Label>
                            </Col>
                            <Col md={4}>
                                <Form.Control
                                    as="select"
                                    className="mt-4 mb-4"
                                    value={selectedGemstoneIndex}
                                    onChange={(e) => setSelectedGemstoneIndex(Number(e.target.value))}
                                >
                                    {otherItems.map((item, index) => (
                                        <option key={index} value={index}>
                                            {item.type ? item.type.charAt(0).toUpperCase() + item.type.slice(1) : ''} {index + 1}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Col>
                        </Row>
                        {renderGemstoneDetails(otherItems)}
                    </div>
                )}
            </>
        );
    };

    const renderGemstoneDetails = (gemstones) => {
        const gemstone = gemstones[selectedGemstoneIndex];
        return (
            <div>
                <Row>
                    {Object.entries(gemstone).map(([key, value], idx) => (
                        <Col md={4} className="mb-2" key={idx}>
                            <div>
                                <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        );
    };

    const renderModalContent = () => {
        if (!currentItem) return null;

        return (
            <Container>
                {renderDetails(currentItem)}
            </Container>
        );
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/approval/assign/${customerId}`);
                setData(response.data.map((item, index) => ({
                    srno: index + 1,
                    items: item.items || "Unnamed Item",
                    number: item.id,
                    group: item.group || "",
                    description: item.description || "",
                    altcode: item.altcode || "",
                    type: item.type,
                    date: new Date(item.created_at).toLocaleString(),
                    ...item,
                })));
            } catch (error) {
                // console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [customerId]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };

    const filteredData = data.filter((row) => {
        return (
            (row.items || "").toLowerCase().includes((filters.items || "").toLowerCase()) &&
            (row.number || "").toString().includes(filters.number || "") &&
            (row.group || "").toLowerCase().includes((filters.group || "").toLowerCase()) &&
            (row.description || "").toLowerCase().includes((filters.description || "").toLowerCase()) &&
            (row.altcode || "").toLowerCase().includes((filters.altcode || "").toLowerCase()) &&
            (row.type || "").toLowerCase().includes((filters.type || "").toLowerCase()) &&
            (row.date || "").toLowerCase().includes((filters.date || "").toLowerCase())
        );
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const renderPagination = () => {
        const totalPages = Math.ceil(filteredData.length / rowsPerPage);
        return (
            <Pagination>
                <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                />
                {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => handlePageChange(index + 1)}
                    >
                        {index + 1}
                    </Pagination.Item>
                ))}
                <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                />
            </Pagination>
        );
    };

    const renderTable = (data) => (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    {["Sr No.", "Items", "Number", "Group", "Description", "Alternative Code", "Type", "Date","Actions"].map(
                        (header, idx) => (
                            <th key={idx}>
                                {header}
                                {header !== "Actions" && (
                                    <input
                                        type="text"
                                        name={header.toLowerCase().replace(/ /g, "")}
                                        value={filters[header.toLowerCase().replace(/ /g, "")] || ""}
                                        onChange={handleFilterChange}
                                        placeholder="Filter"
                                        style={{ width: "100%" }}
                                    />
                                )}
                            </th>
                        )
                    )}
                </tr>
            </thead>
            <tbody>
                {data.map((row, index) => (
                    <tr key={index}>
                        <td>{indexOfFirstRow + index + 1}</td>
                        <td>
                            <Button
                                variant="link"
                                className="text-primary"
                                onClick={() => handleItemClick(row)}
                            >
                                {row.items}
                            </Button>
                        </td>
                        <td>{row.number}</td>
                        <td>{row.group}</td>
                        <td>{row.description}</td>
                        <td>{row.altcode}</td>
                        <td>{row.type}</td>
                        <td>{row.date}</td>
                        <td>
                            <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleRemoveItem(row)}
                            >
                                Return
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );

    return (
        <div className="approval-container">
            <h2>Items Assigned to {customerName} (Customer ID: {customerId})</h2>
            <Container>
                {renderTable(currentRows)}
                {renderPagination()}
            </Container>
            <Modal show={!!currentItem} onHide={handleModalClose} size="lg">
                <Modal.Header id="modalheader" closeButton>
                    <Modal.Title>
                     Item
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body id="modalbody">{renderModalContent()}</Modal.Body>
                <Modal.Footer id="modalheader">
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ItemsAssign;
